export default class Controller {

    update(dt, mousePosition) {
        // nothing.
    }

    isOnScreen() {
        return true;
    }

    render() {
        // nothing.
    }

}
